export default __webpack_public_path__ + "static/media/sico_standing_on_the_top.a662408d.jpg";